<div style="background-color:#00194b ">
  <div style="background-color: #F0F3FA; border-radius: 35px 0 0 0">
    <div class="workspace-overview-body" style="background-color: transparent;padding: 2.2rem 2rem 0; gap: 1.8rem;" *ngIf="codex.showCodex">
      <div class="codex-view-switch-row">
        <span class="go-back-btn" (click)="goBack()">
          <i class="bi bi-chevron-left"></i>
          Go back
        </span>
        <div class="select-codex-view-btns-container">
          <span class="select-codex-view-btn-title">{{ 'codex_change_view' | translate }}</span>
          <div class="select-codex-view-btn" [ngClass]="{'active' : codexView === 'quarter'}" (click)="setCodexView('quarter')">
            <img src="../../../assets/svg/icon_calendar_balck.svg">
            <span class="select-codex-view-btn-title">{{ 'codex_quarter_view' | translate }}</span>
          </div>
          <div class="end-line"></div>
          <div class="select-codex-view-btn" [ngClass]="{'active' : codexView === 'indicator'}" (click)="setCodexView('indicator')">
            <img src="../../../assets/svg/readiness_score.svg">
            <span class="select-codex-view-btn-title">{{ 'codex_indicator_view' | translate }}</span>
          </div>
        </div>
      </div>

      <ng-container *ngIf="codexView === 'quarter'">
      <div class="teams-trends-container" style="padding: 2.8rem;">
        <div class="d-flex justify-content-between align-items-center">
          <div class="trends-dates-dropdown" style="padding-bottom: 30px">
            <h2 style="font-weight: 400; margin-right: 20px">{{ "wo_codex_title"| translate }}</h2>
            <p-dropdown [options]="codex.selector" [(ngModel)]="selectedQuarter" (onChange)="sortReports($event.value.index)"
                        dropdownIcon="bi bi-caret-down-fill" optionLabel="label"></p-dropdown>
          </div>

        </div>
        <div class="trends-container">
          <div class="good-trends-container">
            <div style="background-color: #F0F3FA; border-radius: 15px; padding: 20px">
              <div class="row g-4">
                <div class="col-md-6">
                  <div class="codex-box">
                    <h2 class="wss-title">{{ 'score' | translate }}</h2>
                    <div class="wss-right">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="20 7 100 110" version="1.1" width="260px"
                           height="260px">
                        <path class="grey" d="M40,90
                    A40,40 0 1,1 100,90"
                              style="fill:none;"/>
                        <path [attr.stroke]="knobColor"
                              [attr.stroke-dasharray]="setKnobProgressBar(codex.current.score)" id="svgProgress"
                              class="progress" d="M40,90
                    A40,40 0 1,1 100,90"
                              style="fill:none;"/>
                        <path *ngIf="codex.hasPrevious"
                              [ngClass]="(codex.current.score > codex.previous.score) ?
                        'svgArrowUp' : (codex.current.score > codex.previous.score) ? 'svgArrowDown' : 'svgArrowEven'"
                              d="M15.358,9.708l.837-.837a.9.9,0,0,0,0-1.278L8.871.266a.9.9,0,0,0-1.278,0L.266,7.593a.9.9,0,0,0,0,1.278l.837.837A.906.906,0,0,0,2.4,9.693L6.723,5.151V15.984a.9.9,0,0,0,.9.9H8.833a.9.9,0,0,0,.9-.9V5.151l4.327,4.542A.9.9,0,0,0,15.358,9.708Z"></path>
                        <text class="svgTextValue"
                              [attr.x]="62"
                              y="70">{{ codex.current.score }}
                        </text>
                        <text class="svgTextPercentage"
                              [attr.x]="83"
                              y="70">%
                        </text>
                      </svg>
                    </div>
                    <div class="wss-left">
                      <div *ngIf="codex.hasPrevious" class="wss-last-collector">
                  <span *ngIf="codex.current.score > codex.previous.score">
                    <img style="margin-bottom: .4rem;"
                         src="../../../assets/svg/indicator-arrow-up.svg"><b>{{ (codex.current.score - codex.previous.score) + '% ' }}</b>{{ 'wo_codex_progress_change'|translate }}
                  </span>
                        <span
                          *ngIf="codex.current.score < codex.previous.score">
                    <img style="margin-bottom: .4rem;"
                         src="../../../assets/svg/indicator-arrow-down.svg"><b>{{ (codex.current.score - codex.previous.score) + '% ' }}</b>{{ 'wo_codex_progress_change'|translate }}</span>
                        <span
                          *ngIf="codex.current.score === codex.previous.score"><i
                          [style]="{'color':'#5e5e5e'}"
                          class="bi bi-dash-lg"> </i> 0% {{ 'wo_codex_progress_change'|translate }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div
                      [ngStyle]="{'background-color' : '#DEE4F3', 'border': '1px solid #E4EDFE' }"
                      class="indicator col-md-6">
                      <div style="display: flex">
                        <img
                          [ngStyle]="(indicator['transparent'] == '../../../assets/icons/codex/be-transparent.svg')? {'background-image' : codexIndicatorBackground['be-transparent']} : {'background-color' : data.colors.white, 'border': '2px '+codexIndicatorBackground['be-transparent'] +' solid' }"
                          [src]="indicator['transparent']" class="codex-indicator-image">
                        <span class="codex-indicator-title"
                              style="margin: auto 5px">{{ codex.current.mappedBySlug['be-transparent'].category.title }}</span>
                      </div>
                      <div class="codex-page-indicator-percentage-container col-lg-6 col-md-12">
                        <span
                          class="codex-percentage-value">{{ codex.current.mappedBySlug['be-transparent'].score }}</span>
                        <span class="percentage">%</span>
                        <img *ngIf="codex.hasPrevious" class="indicator-arrow-img" [src]="codex.current.mappedBySlug['be-transparent'].score > codex.previous.mappedBySlug['be-transparent'].score ? '../../../assets/svg/indicator-arrow-up.svg':
                          codex.current.mappedBySlug['be-transparent'].score < codex.previous.mappedBySlug['be-transparent'].score ? '../../../assets/svg/indicator-arrow-down.svg':''">
                        <i *ngIf="codex.current.mappedBySlug['be-transparent'].score != 0"
                           [ngClass]="(codex.current.mappedBySlug['be-transparent'].score === codex.previous.mappedBySlug['be-transparent'].score) ? 'bi bi-dash-lg even':''"
                           class="indicator-status-arrow">
                        </i>
                      </div>
                    </div>

                    <div
                      [ngStyle]="{'background-color' : '#DEE4F3', 'border': '1px solid #E4EDFE' }"
                      class="indicator col-md-6">
                      <div style="display: flex">
                        <img
                          [ngStyle]="(indicator['empower'] == '../../../assets/icons/codex/empower-people.svg')? {'background-image' : codexIndicatorBackground['empower-people']} : {'background-color' : data.colors.white, 'border': '2px '+codexIndicatorBackground['empower-people'] +' solid' }"
                          [src]="indicator['empower']" class="codex-indicator-image">
                        <span class="codex-indicator-title" style="margin: auto 5px">{{ 'codex_3'| translate }}</span>
                      </div>
                      <div class="codex-page-indicator-percentage-container col-lg-6 col-md-12">
                        <span
                          class="codex-percentage-value">{{ codex.current.mappedBySlug['empower-people'].score }}</span>
                        <span class="percentage">%</span>
                        <img *ngIf="codex.hasPrevious" class="indicator-arrow-img" [src]="codex.current.mappedBySlug['empower-people'].score > codex.previous.mappedBySlug['empower-people'].score ? '../../../assets/svg/indicator-arrow-up.svg':
                    codex.current.mappedBySlug['empower-people'].score < codex.previous.mappedBySlug['empower-people'].score ? '../../../assets/svg/indicator-arrow-down.svg':''">
                        <i *ngIf="codex.current.mappedBySlug['empower-people'].score != 0"
                           [ngClass]="(codex.current.mappedBySlug['empower-people'].score === codex.previous.mappedBySlug['empower-people'].score) ? 'bi bi-dash-lg even':''"
                           class="indicator-status-arrow">
                        </i>
                      </div>
                    </div>

                    <div
                      [ngStyle]="{'background-color' : '#DEE4F3', 'border': '1px solid #E4EDFE' }"
                      class="indicator col-md-6">
                      <div style="display: flex">
                        <img
                          [ngStyle]="(indicator['helpful'] == '../../../assets/icons/codex/be-present-&-helpful.svg')? {'background-image' : codexIndicatorBackground['be-present-&-helpful']} : {'background-color' : data.colors.white, 'border': '2px '+codexIndicatorBackground['be-present-&-helpful'] +' solid' }"
                          [src]="indicator['helpful']" class="codex-indicator-image">
                        <span class="codex-indicator-title" style="margin: auto 5px">{{ 'codex_1'| translate }}</span>
                      </div>
                      <div class="codex-page-indicator-percentage-container col-lg-6 col-md-12">
                        <span
                          class="codex-percentage-value">{{ codex.current.mappedBySlug['be-present-&-helpful'].score }}</span>
                        <span class="percentage">%</span>
                        <img *ngIf="codex.hasPrevious" class="indicator-arrow-img" [src]="codex.current.mappedBySlug['be-present-&-helpful'].score > codex.previous.mappedBySlug['be-present-&-helpful'].score ? '../../../assets/svg/indicator-arrow-up.svg':
                    codex.current.mappedBySlug['be-present-&-helpful'].score < codex.previous.mappedBySlug['be-present-&-helpful'].score ? '../../../assets/svg/indicator-arrow-down.svg':''">
                        <i *ngIf="codex.current.mappedBySlug['be-present-&-helpful'].score != 0"
                           [ngClass]="(codex.current.mappedBySlug['be-present-&-helpful'].score === codex.previous.mappedBySlug['be-present-&-helpful'].score) ? 'bi bi-dash-lg even':''"
                           class="indicator-status-arrow">
                        </i>
                      </div>
                    </div>


                    <div
                      [ngStyle]="{'background-color' : '#DEE4F3', 'border': '1px solid #E4EDFE' }"
                      class="indicator col-md-6">
                      <div style="display: flex">
                        <img
                          [ngStyle]="(indicator['inspirational'] == '../../../assets/icons/codex/be-inspirational.svg')? {'background-image' : codexIndicatorBackground['be-inspirational']} : {'background-color' : data.colors.white, 'border': '2px '+codexIndicatorBackground['be-inspirational']+' solid' }"
                          [src]="indicator['inspirational']" class="codex-indicator-image">
                        <span class="codex-indicator-title" style="margin: auto 5px">{{ 'codex_2'| translate }}</span>
                      </div>
                      <div class="codex-page-indicator-percentage-container col-lg-6 col-md-12">
                        <span
                          class="codex-percentage-value">{{ codex.current.mappedBySlug['be-inspirational'].score }}</span>
                        <span class="percentage">%</span>
                        <img *ngIf="codex.hasPrevious" class="indicator-arrow-img" [src]="codex.current.mappedBySlug['be-inspirational'].score > codex.previous.mappedBySlug['be-inspirational'].score ? '../../../assets/svg/indicator-arrow-up.svg':
                    codex.current.mappedBySlug['be-inspirational'].score < codex.previous.mappedBySlug['be-inspirational'].score ? '../../../assets/svg/indicator-arrow-down.svg':''">
                        <i *ngIf="codex.current.mappedBySlug['be-inspirational'].score != 0"
                           [ngClass]="(codex.current.mappedBySlug['be-inspirational'].score === codex.previous.mappedBySlug['be-inspirational'].score) ? 'bi bi-dash-lg even':''"
                           class="indicator-status-arrow">
                        </i>
                      </div>
                    </div>

                    <div
                      [ngStyle]="{'background-color' : '#DEE4F3', 'border': '1px solid #E4EDFE' }"
                      class="indicator col-md-6">
                      <div style="display: flex">
                        <img
                          [ngStyle]="(indicator['direction'] == '../../../assets/icons/codex/set-a-clear-direction.svg')? {'background-image' : codexIndicatorBackground['set-a-clear-direction']} : {'background-color' : data.colors.white, 'border': '2px '+codexIndicatorBackground['set-a-clear-direction']+' solid' }"
                          [src]="indicator['direction']" class="codex-indicator-image">
                        <span class="codex-indicator-title" style="margin: auto 5px">{{ 'codex_4'| translate }}</span>
                      </div>
                      <div class="codex-page-indicator-percentage-container col-lg-6 col-md-12">
                        <span
                          class="codex-percentage-value">{{ codex.current.mappedBySlug['set-a-clear-direction'].score }}</span>
                        <span class="percentage">%</span>
                        <img *ngIf="codex.hasPrevious" class="indicator-arrow-img" [src]="codex.current.mappedBySlug['set-a-clear-direction'].score > codex.previous.mappedBySlug['set-a-clear-direction'].score ? '../../../assets/svg/indicator-arrow-up.svg':
                    codex.current.mappedBySlug['set-a-clear-direction'].score < codex.previous.mappedBySlug['set-a-clear-direction'].score ? '../../../assets/svg/indicator-arrow-down.svg':''">
                        <i *ngIf="codex.current.mappedBySlug['set-a-clear-direction'].score != 0"
                           [ngClass]="(codex.current.mappedBySlug['set-a-clear-direction'].score === codex.previous.mappedBySlug['set-a-clear-direction'].score) ? 'bi bi-dash-lg even':''"
                           class="indicator-status-arrow">
                        </i>
                      </div>
                    </div>

                    <div class=" col-md-6"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="teams-trends-container" style="margin-bottom: 30px">
        <div style="display: flex">
          <button [ngClass]="tab === 0 ? 'active-tab-button':'inactive-tab-button'" (click)="tab = 0">
            {{ 'codex_tab1'| translate }}
          </button>
          <button [ngClass]="tab === 1 ? 'active-tab-button':'inactive-tab-button'" (click)="tab = 1"
                  style="margin-left: 10px">
            {{ 'codex_tab2'| translate }}
          </button>
        </div>

        <div *ngIf="tab === 0">
          <table class="tab-1-table">
            <colgroup>
              <col style="width:30%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:10%">
              <col style="width:8%">
              <col style="width:12%">
            </colgroup>
            <tr>
              <th style="text-align: left; padding-left: 10px">{{ 'team' | translate }}</th>
              <th #origin1="cdkOverlayOrigin" cdkOverlayOrigin>
                <img [src]="'../../../assets/icons/codex/be-transparent_black.svg'" style="height: 24px; width: 24px">
                <!-- <img class="sorting-icon" alt="sorting_icon" src="../../../assets/svg/lc_sorting_icon.svg"> -->
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('be-transparent')}"
                  (click)="openSortMenu('be-transparent')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin1"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'be-transparent'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-transparent', 'ASC')"
                        (change)="toggleSort('be-transparent', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-transparent', 'DESC')"
                        (change)="toggleSort('be-transparent', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin2="cdkOverlayOrigin" cdkOverlayOrigin>
                <img [src]="'../../../assets/icons/codex/be-present-&-helpful_black.svg'"
                       style="height: 24px; width: 24px">
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('be-present-&-helpful')}"
                  (click)="openSortMenu('be-present-&-helpful')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin2"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'be-present-&-helpful'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-present-&-helpful', 'ASC')"
                        (change)="toggleSort('be-present-&-helpful', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-present-&-helpful', 'DESC')"
                        (change)="toggleSort('be-present-&-helpful', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin3="cdkOverlayOrigin" cdkOverlayOrigin>
                <img [src]="'../../../assets/icons/codex/set-a-clear-direction_black.svg'"
                       style="height: 24px; width: 24px">
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('set-a-clear-direction')}"
                  (click)="openSortMenu('set-a-clear-direction')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin3"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'set-a-clear-direction'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('set-a-clear-direction', 'ASC')"
                        (change)="toggleSort('set-a-clear-direction', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('set-a-clear-direction', 'DESC')"
                        (change)="toggleSort('set-a-clear-direction', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin4="cdkOverlayOrigin" cdkOverlayOrigin>
                <img [src]="'../../../assets/icons/codex/empower-people_black.svg'" style="height: 24px; width: 24px">
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('empower-people')}"
                  (click)="openSortMenu('empower-people')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin4"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'empower-people'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('empower-people', 'ASC')"
                        (change)="toggleSort('empower-people', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('empower-people', 'DESC')"
                        (change)="toggleSort('empower-people', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin5="cdkOverlayOrigin" cdkOverlayOrigin>
                <img [src]="'../../../assets/icons/codex/be-inspirational_black.svg'"
                       style="height: 24px; width: 24px">
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('be-inspirational')}"
                  (click)="openSortMenu('be-inspirational')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin5"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'be-inspirational'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-inspirational', 'ASC')"
                        (change)="toggleSort('be-inspirational', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('be-inspirational', 'DESC')"
                        (change)="toggleSort('be-inspirational', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin6="cdkOverlayOrigin" cdkOverlayOrigin class="d-flex align-items-center justify-content-center gap-2" style="height: 3.4rem;">
                {{ 'average_score' | translate | uppercase }}
                <i class="bi bi-filter sorting-icon icon-flex-alignment"
                  [ngClass]="{'show-badge' : hasActiveSort('average_score')}"
                  (click)="openSortMenu('average_score')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin6"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'average_score'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('average_score', 'ASC')"
                        (change)="toggleSort('average_score', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('average_score', 'DESC')"
                        (change)="toggleSort('average_score', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
              <th #origin7="cdkOverlayOrigin" cdkOverlayOrigin>
                {{ 'development' | translate | uppercase }}
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('development')}"
                  (click)="openSortMenu('development')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin7"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'development'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('development', 'ASC')"
                        (change)="toggleSort('development', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('development', 'DESC')"
                        (change)="toggleSort('development', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
            </tr>
            <tr *ngFor="let team of teams.current">
              <td class="table-cell d-flex align-items-center">
                <span (click)="goToTeam(team.team.uuid)" class="team-name">{{ team.team.name }}</span>
              </td>
              <td class="table-cell" [style]="{'background-color': team?.slug['be-transparent']?.color}"
                  pTooltip="{{team?.slug['be-transparent'].category?.title}}"
                  tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                {{ team?.slug['be-transparent'].score }}%
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible" [src]=" team?.slug['be-transparent'].score > teams.previous[team.team.uuid].slug['be-transparent'].score
                ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
              </td>
              <td class="table-cell" [style]="{'background-color': team?.slug['be-present-&-helpful']?.color}"
                  pTooltip="{{team?.slug['be-present-&-helpful']?.category?.title}}"
                  tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                {{ team?.slug['be-present-&-helpful']?.score }}%
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible" [src]=" team?.slug['be-present-&-helpful']?.score > teams.previous[team.team.uuid].slug['be-present-&-helpful']?.score
                ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
              </td>
              <td class="table-cell" [style]="{'background-color': team?.slug['set-a-clear-direction']?.color}"
                  pTooltip="{{team?.slug['set-a-clear-direction']?.category?.title}}"
                  tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                {{ team?.slug['set-a-clear-direction']?.score }}%
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible" [src]=" team?.slug['set-a-clear-direction']?.score > teams.previous[team.team.uuid].slug['set-a-clear-direction']?.score
                ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
              </td>
              <td class="table-cell" [style]="{'background-color': team?.slug['empower-people']?.color}"
                  pTooltip="{{team?.slug['empower-people']?.category?.title}}"
                  tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                {{ team?.slug['empower-people']?.score }}%
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible" [src]=" team?.slug['empower-people']?.score > teams.previous[team.team.uuid].slug['empower-people']?.score
                ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
              </td>
              <td class="table-cell" [style]="{'background-color': team?.slug['be-inspirational']?.color}"
                  pTooltip="{{team?.slug['be-inspirational']?.category?.title}}"
                  tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom">
                {{ team?.slug['be-inspirational']?.score }}%
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible" [src]=" team?.slug['be-inspirational']?.score > teams.previous[team.team.uuid].slug['be-inspirational']?.score
                ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
              </td>

              <td class="table-cell" style="font-weight: bolder; font-size: 1.8rem"
                  [ngStyle]="{'color' : getColor(team.score, true) }">{{ team.score }}%
              </td>
              <td class="table-cell">
                <img *ngIf="teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible && team?.progress !== 0"
                  [src]="team?.progress > 0
                  ?'../../../assets/svg/indicator-arrow-up.svg': '../../../assets/svg/indicator-arrow-down.svg'" alt="">
                {{ teams.previous[team.team.uuid] && teams.previous[team.team.uuid]?.previousReportEligible ? (team?.progress + '%') : '-' }}
              </td>
            </tr>
          </table>
        </div>
        <div *ngIf="tab === 1 && questions.current.length">
          <table class="tab-1-table">
            <colgroup>
              <col style="width:5%">
              <col style="width:29%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:8%">
              <col style="width:10%">
            </colgroup>
            <tr>
              <th>CODEX</th>
              <th style="text-align: left; padding-left: 5px">STATEMENT</th>
              <th>{{ 'tryit_option1' | translate | uppercase }}</th>
              <th>{{ 'tryit_option2' | translate | uppercase }}</th>
              <th>{{ 'tryit_option3' | translate | uppercase }}</th>
              <th>{{ 'middle' | translate | uppercase }}</th>
              <th>{{ 'tryit_option5' | translate | uppercase }}</th>
              <th>{{ 'tryit_option6' | translate | uppercase }}</th>
              <th>{{ 'tryit_option7' | translate | uppercase }}</th>
              <th #origin8="cdkOverlayOrigin" cdkOverlayOrigin>
                SCORE
                <i class="bi bi-filter sorting-icon"
                  [ngClass]="{'show-badge' : hasActiveSort('statement-score')}"
                  (click)="openSortMenu('statement-score')"
                  pBadge badgeDot severity="info">
                </i>
                <ng-template
                  cdkConnectedOverlay
                  [cdkConnectedOverlayOrigin]="origin8"
                  [cdkConnectedOverlayOpen]="activeMenuCategory === 'statement-score'"
                  (backdropClick)="activeMenuCategory = null"
                  [cdkConnectedOverlayHasBackdrop]="true"
                  cdkConnectedOverlayBackdropClass="transparent-backdrop">
                  <div class="sorting-main-container">
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('statement-score', 'ASC')"
                        (change)="toggleSort('statement-score', 'ASC')">
                      <span style="font-size: 1.4rem;">Ascending</span>
                    </label>
                    <label class="d-flex align-items-center gap-3 m-0 cursor-pointer">
                      <input
                        class="sorting-checkbox"
                        type="checkbox"
                        [checked]="isChecked('statement-score', 'DESC')"
                        (change)="toggleSort('statement-score', 'DESC')">
                      <span style="font-size: 1.4rem;">Descending</span>
                    </label>
                  </div>
                </ng-template>
              </th>
            </tr>
            <tr *ngFor="let statement of questions.current">
              <td>
                <div class="table-cell" style="height: 40px; width: 40px"
                     pTooltip="{{statement.category.title}}" tooltipStyleClass="member-email-tooltip" tooltipPosition="bottom"
                     [style]="{'background-image': statement.iconColorGradient}">
                  <img [src]="'../../../assets/icons/codex/'+statement.category.slug+'.svg'"
                       style="height: 20px; margin-top: 4px" alt="">
                </div>
              </td>
              <td>
                <div class="table-cell"><p style="text-align: left; padding: 5px">{{ statement.question }}</p></div>
              </td>

              <td class="table-cell"
                  [ngClass]="statement.mapped['totally-disagree'].color ? 'bold-box' :''">{{ statement.mapped['totally-disagree'].percentage }}%</td>
              <td class="table-cell"
                [ngClass]="statement.mapped['mostly-disagree'].color ? 'bold-box' :''">{{ statement.mapped['mostly-disagree'].percentage }}%
              </td>
              <td class="table-cell"
                  [ngClass]="statement.mapped['slightly-disagree'].color ? 'bold-box' :''">{{ statement.mapped['slightly-disagree'].percentage }}%
              </td>
              <td class="table-cell"
                  [ngClass]="statement.mapped['i-m-right-in-the-middle'].color ? 'bold-box' :''">{{ statement.mapped['i-m-right-in-the-middle'].percentage }}%
              </td>
              <td class="table-cell"
                  [ngClass]="statement.mapped['slightly-agree'].color ? 'bold-box' :''">{{ statement.mapped['slightly-agree'].percentage }}%
              </td>
              <td class="table-cell"
                  [ngClass]="statement.mapped['mostly-agree'].color ? 'bold-box' :''">{{ statement.mapped['mostly-agree'].percentage }}%
              </td>
              <td class="table-cell"
                  [ngClass]="statement.mapped['totally-agree'].color ? 'bold-box' :''">{{ statement.mapped['totally-agree'].percentage }}%
              </td>







              <td class="table-cell" style="font-weight: bolder"
                  [style]="{'background-color': getColor(statement.score, false)}">
                {{ statement.score }}%
              </td>
            </tr>
          </table>
        </div>
      </div>
      </ng-container>

      <app-codex-indicator-view *ngIf="codexView === 'indicator' && showCategoryStatements"
        [currentReport]="indicatorReport"
        [codexesByCategory]="codexesByCategory"
        (indicatorChanges)="questionCategoryChanged($event)">
      </app-codex-indicator-view>
    </div>
  </div>
</div>
